import { AppIntegrationsRepository, DevicesRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

const _directiveDependencies = ['Templates'];
const _controllerDependencies = ['$scope', 'Util', 'DeployRestService'];

class OfflineDeploymentController {

    constructor(
        $scope, Util,
        DeployRestService,
    ) {

        this.$scope = $scope;
        this.Util = Util;
        this.DevicesRepository = DevicesRepository;
        this.DeployRestService = DeployRestService;

        this.cdnUrl = CWCONFIG.cdn;
        this.randomNumber = Math.floor((Math.random() * 1000) + 1);

        this.app = AppIntegrationsRepository.getById(this.$scope.inputData.appId);

        if (!this.app) {

            // app not found, close modal
            this.Util.closeModal();

        } else {

            this._deploy();

        }

    }

    _deploy() {

        this.deploying = true;
        const device = this.DevicesRepository.getById(this.$scope.inputData.deviceId);
        const deploymentPayload = {
            deviceId: device.id,
            userId: this.Util.deepFind(device, 'relationships.user.data.id'),
            appId: this.app.id,
        };

        this.DeployRestService
            .deployOnDevice(deploymentPayload)
            .then(() => {

                this.deploying = false;
                this.$scope.deployOnDeviceSuccess()(device, this.app.id, {});

            })
            .then(null, (e) => {

                // 409 === Conflict
                // An instance for this application already exists (pending)
                // Do not hide the modal
                if (e.status === 409) {

                    this.deploying = false;
                    return;

                }

                Alert.error({
                    message: 'cw.modal.server-error.desc',
                    icon: {
                        cssClasses: `icon-${this.Util.deepFind(device, 'attributes.type')}`,
                    },
                });
                this.Util.closeModal();

            });

    }

    close() {

        this.Util.closeModal();

    }

}

class OfflineDeploymentDirective {

    constructor() {

        this.template = require('./offline-deployment.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, Util, DeployRestService) =>
            new OfflineDeploymentController($scope, Util, DeployRestService));

        this.controller = _controllerDependencies;
        this.controllerAs = 'OfflineDeploymentCtrl';

    }

}


_directiveDependencies.push(() =>
    new OfflineDeploymentDirective());

angular.module('directives')
    .directive('offlineDeployment', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/offline-deployment/offline-deployment.js